import { RemoveCircleOutline } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useState } from 'react'

import {
  ERROR_NOTIFICATION_OPTIONS,
  SUCCESS_NOTIFICATION_OPTIONS,
} from '../../configs/constants'
import { ActionCreatorWithPayload } from '@reduxjs/toolkit'
import { AddRemoveEntityUserPayload } from '../../store/slices/models'
import { useAppDispatch } from '../../store/hooks'

interface RemoveEntityUserButtonProps {
  userId: string
  userEmail: string
  entityId: string
  entityName: string
  entityAction: ActionCreatorWithPayload<AddRemoveEntityUserPayload, string>
  postActionHandler?: () => void
}

const RemoveEntityUserButton = ({
  userEmail,
  userId,
  entityAction,
  entityId,
  entityName,
  postActionHandler,
}: RemoveEntityUserButtonProps) => {
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleConfirm = () => {
    dispatch(
      entityAction({
        userId,
        entityId,
        postSuccessHandler: () => {
          if (postActionHandler) postActionHandler()
          enqueueSnackbar(
            'User removed successfully!',
            SUCCESS_NOTIFICATION_OPTIONS
          )
        },
        errorHandler: () => {
          enqueueSnackbar('Failed to remove user!', ERROR_NOTIFICATION_OPTIONS)
        },
      })
    )
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <RemoveCircleOutline color="error" />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Confirm the action
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Do you really want to remove ${userEmail} from ${entityName}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleConfirm}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RemoveEntityUserButton
